export default __webpack_public_path__ + "static/media/No6Open.67e6ee02.jpg";